import React from "react";
import KioskStartButton from "../components/start-button";
// import { useTranslation } from "react-i18next";

export default function TermsKiosk({ navigate, setInputWeight }) {
  const handleSubmit = () => {
    setInputWeight(0);
    navigate("place-bricks");
  };

  return (
    <div className="flex flex-col items-center justify-between w-full h-full px-[4vh]">
      <div className="flex flex-col">
        <h1 className="text-[122px] text-center max-w-[50vh] text-white mt-[3vh] px-[4vh] leading-[130%]">
          Quick check
        </h1>
        <label className="mb-regular text-[90px] text-white font-medium text-center mt-[40px]">
          Did you accept the terms & conditions when you arrived at the store?
        </label>
      </div>
      <div className="grid grid-cols-2 w-full pb-2 pt-large gap-[2vh] relative z-10">
        <KioskStartButton className="w-full" onClick={() => navigate("start")}>
          No, Exit
        </KioskStartButton>
        <KioskStartButton
          className="w-full font-bold"
          onClick={() => handleSubmit()}
          color="yellow"
          icon="check"
          iconColor="black"
        >
          Yes, Continue
        </KioskStartButton>
      </div>
    </div>
  );
}
